// extracted by mini-css-extract-plugin
export default {"root":"EvipSimilarItems-root","title":"EvipSimilarItems-title"};